import React from "react";
import { Col, Container, Row } from "reactstrap";
import { Link } from "react-router-dom";
import "../styles/project.css";
import AutoPort from '../Assests/automios.png';
import PdfSite from '../Assests/pdfsite.png';
import BlogSite from '../Assests/blogsite1.png';

const Project = () => {
  return (
    <Container fluid className="project">
      <Row className="text-center">
        <h1>Project</h1>
        <span className="pro-sub-head">
          Crafting digital excellence through innovation and precision, project
          by project.
        </span>
        <div className="pro-pro-card">
          <Col>
            <div class="card-group">
              <div class="card pro-card">
                <img src={AutoPort} class="card-img-top" alt="..." />
                <div class="card-body project-card-body">
                  <h5 class="card-title">Portfolio</h5>
                  <p class="card-text">
                    Transformed a company's digital presence with a sleek,
                    responsive portfolio. Meticulously crafted and coded on the
                    front-end for a polished user experience.
                  </p>
                </div>
                <div class="card-footer">
                  <Link
                    to="http://three-js-studio.automios.com/?_gl=1*17ijgrv*_ga*MTMwNzE1MjgzLjE2OTM4MDA2MDM.*_ga_8MLZX3E4J2*MTcwMzc4Nzc3My4xMy4xLjE3MDM3ODgwNjMuMC4wLjA."
                    style={{ textDecoration: "none" }}
                    target="blank"
                  >
                    visit site
                  </Link>
                </div>
              </div>
              <div class="card pro-card">
                <img src={PdfSite} class="card-img-top" alt="..." />
                <div class="card-body  project-card-body">
                  <h5 class="card-title">PDF Tool site</h5>
                  <p class="card-text">
                    Elevated user experience on a PDF tools website through
                    meticulous front-end development. Ensured 
                    responsiveness for optimal accessibility across devices.
                  </p>
                </div>
                <div class="card-footer">
                  <Link
                    to="https://6545e5c686d5724b2258762d--gilded-heliotrope-36fbe6.netlify.app/"
                    style={{ textDecoration: "none" }}
                    target="blank"
                  >
                    visit site
                  </Link>
                </div>
              </div>
              <div class="card pro-card">
                <img src={BlogSite} class="card-img-top" alt="..." />
                <div class="card-body  project-card-body">
                  <h5 class="card-title">Blog site</h5>
                  <p class="card-text">
                    Crafted captivating user interfaces for a blockchain blog
                    site, pushing the boundaries of front-end development to
                    engage and inform visitors.
                  </p>
                </div>
                <div class="card-footer">
                  <Link
                    to="https://65783ed14b129247846f6d33--elaborate-bublanina-cb280b.netlify.app/"
                    style={{ textDecoration: "none" }}
                    target="blank"
                  >
                    visit site
                  </Link>
                </div>
              </div>
            </div>
          </Col>
        </div>
        <p className="pro-sub-head2">
          Passionate about crafting exceptional digital experiences, I eagerly
          await the opportunity to contribute my expertise to your projects.
          Let's collaborate and bring your vision to life!
        </p>
        <br />
        <div>
          <button className="hire-me">Hire Me</button>
        </div>
      </Row>
    </Container>
  );
};

export default Project;
